import { render } from "./UserDp.vue?vue&type=template&id=547d50a2&scoped=true"
import script from "./UserDp.vue?vue&type=script&lang=js"
export * from "./UserDp.vue?vue&type=script&lang=js"

import "./UserDp.vue?vue&type=style&index=0&id=547d50a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547d50a2"]])

export default __exports__